// API para páginas PÚBLICAS (sem login) — não anexa token nem redireciona em 401.
// Usada pela página de pré-cadastro de freezer do vendedor (/m/freezer).
import axios from 'axios'

export const publicApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  timeout: 30000,
})
